<template>
  <div class="avatar-cropper">
    <div
      class="avatar-cropper-overlay"
      :class="{'avatar-cropper-overlay-inline': inline}"
      v-if="dataUrl"
    >
      <div class="avatar-cropper-mark" v-if="!inline">
        <a
          @click="cancel"
          class="avatar-cropper-close"
          :title="labels.cancel"
          href="javascript:;"
        >&times;</a>
      </div>
      <v-card class="neu-glow">
        <v-card-title>
          Ritaglia Immagine
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop.prevent="submit">
                <v-icon color="info">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.stop.prevent="cancel">
                <v-icon color="info">mdi-close-circle</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni</span>
          </v-tooltip>          
        </v-card-title>
        <v-card-text> 
          <div class="avatar-cropper-container">
            <div class="avatar-cropper-image-container">
              <img
                :src="dataUrl"
                @load.stop="createCropper"
                alt
                ref="img"
              >
            </div>
          </div>          
        </v-card-text> 
        <!--
          <v-card-actions>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click.stop.prevent="cancel" color="info" v-bind="attrs" v-on="on">
                  <v-icon class="mr-2">mdi-close-box</v-icon>
                  <span class="d-none d-md-block">Esci</span>
                </v-btn>
              </template>
              <span>Esci</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click.stop.prevent="submit" color="green" v-bind="attrs" v-on="on">
                  <v-icon class="mr-2">mdi-save</v-icon>
                  <span class="d-none d-md-block">Salva</span>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
          </v-card-actions>-->
      </v-card>
    </div>
    <input
      :accept="mimes"
      class="avatar-cropper-img-input"
      ref="input"
      type="file"
    >
  </div>
</template>

<script>
import 'cropperjs/dist/cropper.css'
import Cropper from 'cropperjs'

export default {
  props: {
    trigger: {
      type: [String, Element],
      required: true
    },
    uploadHandler: {
      type: Function
    },
    uploadUrl: {
      type: String
    },
    requestMethod: {
      type: String,
      default: 'POST'
    },
    uploadHeaders: {
      type: Object,
      default() {
        return {
          Authorization: sessionStorage.getItem("jwt")
        }
      }
    },
    uploadFormName: {
      type: String,
      default: 'file'
    },
    uploadFormData: {
      type: Object,
      default() {
        return {}
      }
    },
    cropperOptions: {
      type: Object,
      default() {
        return {
          aspectRatio: 1,
          dragMode: 'move',
          autoCropArea: 0.8,
          viewMode: 1,
          movable: true,
          zoomable: true,
          center: true,
          highlight: true,
          cropBoxMovable: true,
          cropBoxResizable: false
        }
      }
    },
    outputOptions: {
      type: Object,
      default() {
        return {
          width: 300,
          height: 300,
          minWidth: 300,
          minHeight: 300,
          maxWidth: 600,
          maxHeight: 600,
          fillColor: '#fff',
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high',
        }
      }
    },
    outputMime: {
      type: String,
      default: null
    },
    outputQuality: {
      type: Number,
      default: 1
    },
    mimes: {
      type: String,
      default: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon'
    },
    labels: {
      type: Object,
      default() {
        return {
          submit: 'Submit',
          cancel: 'Cancel'
        }
      }
    },
    withCredentials: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      page: "Account",
      cropper: undefined,
      dataUrl: undefined,
      filename: undefined
    }
  },
  methods: {
    destroy() {
      this.cropper.destroy()
      this.$refs.input.value = ''
      this.dataUrl = undefined
    },
    submit() {
      this.$emit('submit')
      if (this.uploadUrl) {
        this.uploadImage()
      } else if (this.uploadHandler) {
        this.uploadHandler(this.cropper)
      } else {
        this.$emit('error', 'No upload handler found.', 'user')
      }
      this.destroy()
    },
    cancel(){
        this.$emit('cancel')
        this.destroy();
    },
    pickImage(e) {
      this.$refs.input.click()
      e.preventDefault()
      e.stopPropagation()
    },
    createCropper() {
      this.cropper = new Cropper(this.$refs.img, this.cropperOptions)
    },
    uploadImage() {
      this.cropper.getCroppedCanvas(this.outputOptions).toBlob(
        blob => {
          let form = new FormData()
          let xhr = new XMLHttpRequest()
          let data = Object.assign({}, this.uploadFormData)
          
          xhr.withCredentials = this.withCredentials;

          for (let key in data) {
            form.append(key, data[key])
          }

          form.append(this.uploadFormName, blob, this.filename)

          this.$emit('uploading', {form, xhr})

          xhr.open(this.requestMethod, this.uploadUrl, true)

          for (let header in this.uploadHeaders) {
            console.log(222,this.uploadHeaders,header,this.uploadHeaders[header])
            xhr.setRequestHeader(header, this.uploadHeaders[header])
          }
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              let response = ''
              try {
                response = JSON.parse(xhr.responseText)
              } catch (err) {
                response = xhr.responseText
              }
              var form1=this.uploadFormData;
              console.log(242,response,this.uploadFormData);
              this.$emit('completed', { response,form1 })
              
              if (response.Status=='OK') {
                this.$emit('uploaded', { form, form1 })
                //this.$store.dispatch("setAvatar", response.Payload);
              } else {
                this.$emit('error', 'Image upload fail.', 'upload', xhr)
              }
              /*
              if ([200, 201, 204].indexOf(xhr.status) > -1) {
                this.$emit('uploaded', response, form, xhr)
                 this.$store.dispatch("setAvatar", '');
              } else {
                this.$emit('error', 'Image upload fail.', 'upload', xhr)
              }
              */
            }
          }
          xhr.send(form)
        },
        //this.outputMime
        'image/jpeg',
        this.outputQuality
      )
    }
  },
  mounted() {
    // listen for click event on trigger
    let trigger =
      typeof this.trigger == 'object'
        ? this.trigger
        : document.querySelector(this.trigger)
        console.log(266,trigger);
    if (!trigger) {
      this.$emit('error', 'No avatar make trigger found.', 'user')
    } else {
      trigger.addEventListener('click', this.pickImage)
    }

    // listen for input file changes
    let fileInput = this.$refs.input
    console.log(274,fileInput);
    fileInput.addEventListener('change', () => {
      if (fileInput.files != null && fileInput.files[0] != null) {
        let correctType = this.mimes.split(', ').find(m => m === fileInput.files[0].type);
        if (!correctType) {
          this.$emit('error', 'File type not correct.', 'user');
          return;
        }
        let reader = new FileReader()
        reader.onload = e => {
          this.dataUrl = e.target.result
        }

        reader.readAsDataURL(fileInput.files[0])

        this.filename = fileInput.files[0].name || 'unknown'
        this.mimeType = this.mimeType || fileInput.files[0].type
        this.$emit('changed', fileInput.files[0], reader)
      }
    })
  }
}
</script>

<style lang="scss">
.avatar-cropper {
  .avatar-cropper-overlay {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
  }
  .avatar-cropper-overlay-inline{
     position: initial;
  }

  .avatar-cropper-img-input {
    display: none;
  }

  .avatar-cropper-close {
    float: right;
    padding: 20px;
    font-size: 3rem;
    color: #fff;
    font-weight: 100;
    text-shadow: 0px 1px rgba(40, 40, 40, 0.3);
  }

  .avatar-cropper-mark {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .avatar-cropper-container {
    background: #fff;
    z-index: 999;
    box-shadow: 1px 1px 5px rgba(100, 100, 100, 0.14);

    .avatar-cropper-image-container {
      position: relative;
      max-width: 600px;
      height: 500px;
    }
    img {
      max-width: 100%;
      height: 100%;
    }

    .avatar-cropper-footer {
      display: flex;
      align-items: stretch;
      align-content: stretch;
      justify-content: space-between;

      .avatar-cropper-btn {
        width: 50%;
        padding: 15px 0;
        cursor: pointer;
        border: none;
        background: transparent;
        outline: none;
        &:hover {
          background-color: #2aabd2;
          color: #fff;
        }
      }
    }
  }
}
</style>
